module.exports = __webpack_public_path__ + "img/resellerSummerEvent.d3932afa.jpg";